import { postFetch } from '../fetch';

import { apiConfig } from '../config';

export interface Pane {
    content: string;
    language: string;
    name: string;
    opened?: true;
}

/**
 * Закидывает файлы-статику на сервер (в сервис фейнман практикума)
 */
export function postStatic(panes: Pane[]): Promise<{ key: string }> {
    const { apiPostStatic } = apiConfig.getStaticUrls();

    return postFetch(apiPostStatic, { panes });
}
